<template>
    <div id="main">
        <div class="page">
            <!-- Título -->
            <div class="produto vertical-flow">
                <h1 class="title">{{ $t('produtos') }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a class="a-inativo">{{ $t('vendas') }}</a>
                        </li>
                        <li>
                            <a class="a-inativo">{{ $t('cadastros') }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{ $t('produtos') }}</a>
                        </li>
                    </ul>
                </nav>

                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="msg-busca-ven-produto-campos"
                        />
                    </div>
                </div>

                <div class="produto-table registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="allprodutos"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="$t(f.key)"
                            :width="f.width"
                            :class="''"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: 'edit-venda-produtos',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    {{ props.row[f.key] }}
                                </router-link>
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilterBar from '@/components/shared/Filter';
import ProdutoService from '@/services/vendas/produto/ProdutoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        FilterBar,
        ContainerLoader,
    },
    data() {
        return {
            allprodutos: [],
            service: null,
            fields: [
                { key: 'idproduto', width: 80, sortable: true },
                { key: 'descricao', width: null, sortable: true },
                { key: 'idprodutoerp', width: 130, sortable: true },
                { key: 'codbarras', width: 170, sortable: true },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            isOrdering: false,
            modalOpen: false,
            allowDelete: false,
            sort: {
                order: 'asc',
                column: 'DESCRICAO',
            },
            debouncedOnSearch: null,
            permissao: {},
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'venda-produtos');
        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'produtos' },
            });
        this.service = new ProdutoService(this.$http, this.$router);
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    1,
                    1,
                    this.sort,
                    this.queryFilter
                )
                .then((value) => {
                    this.pagination.totalRows = value.totalElements;
                    if (value.content) {
                        this.allprodutos = value.content;
                    }
                    this.isEmpty = this.allprodutos.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar listagem de pedidos.', e);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            if (body && body.content) {
                let produtolist = body.content.map((mf) => {
                    return {
                        id: mf.idproduto,
                        descricao: mf.descricao,
                    };
                });
                return produtolist;
            } else {
                return [];
            }
        },
        sortTable(field, order) {
            this.sort.column = field;
            this.sort.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }

    .produto .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
    }

    .produto .search-and-filter .search-bar {
        width: 100%;
    }

    .produto .search-and-filter .filter-bar {
        width: 31%;
    }

    .produto-table {
        font-size: 14px;
    }
}
</style>
